// extracted by mini-css-extract-plugin
export default {"error":"Error_error__94Mlh","error-link":"Error_error-link__eQZrx"};